module.exports = __webpack_public_path__ + "static/media/sate-ayam.40e7dee4.svg";